import React, { useEffect, useState } from "react";
import { loadingState, subscribeLoading } from "../utility/loadingBar";
import { isPortalPath } from "./PortalSkeleton";
import "./LoadingBar.css";

// The thin bar that moves left to right along the top of the window while a
// portal screen or its data loads (utility/loadingBar has who starts it). It
// is the bar the last visit's copy shows along its own top edge
// (LastVisit.css uses the same .evLoadBar look), and it stays hidden while
// such a copy is up: one bar at a time.
// It shows only after SHOW_AFTER_MS (quick loads don't flash it) and, once
// shown, stays at least MIN_SHOWN_MS. Account and office pages only. One in
// the app (App.js, outside its Suspense so a screen's download keeps it),
// plus the one drawn with the sign-in skeleton before the app's tree exists.

const SHOW_AFTER_MS = 150;
const MIN_SHOWN_MS = 300;

export const TopLoadingBar = () => {
  const [state, setState] = useState(loadingState);
  const [shown, setShown] = useState(false);

  useEffect(() => subscribeLoading(() => setState(loadingState())), []);

  const want = state.loading && !state.copy && isPortalPath(window.location.pathname);
  useEffect(() => {
    if (want && !shown) {
      const t = setTimeout(() => setShown(true), SHOW_AFTER_MS);
      return () => clearTimeout(t);
    }
    if (!want && shown) {
      const t = setTimeout(() => setShown(false), MIN_SHOWN_MS);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [want, shown]);

  if (!shown) return null;
  return (
    <div className="evTopLoad" role="progressbar" aria-label="Loading" aria-busy="true" data-testid="top-loading-bar">
      <span className="evLoadBar" />
    </div>
  );
};

export default TopLoadingBar;
